import { buildUrl } from "shared/utils";
import { VENUE_PATHS } from "Venues/router";

export const getVenueUrlWithEvent = (venueId: string, eventId?: string) =>
  buildUrl(
    VENUE_PATHS.VENUE,
    { venueId },
    "",
    eventId ? { eventId } : undefined
  );

export const getStageUrlWithEvent = (
  venueId: string,
  stageId: string,
  eventId?: string
) =>
  buildUrl(
    VENUE_PATHS.STAGE,
    { venueId, stageId },
    "",
    eventId ? { eventId } : undefined
  );
